module.exports = __webpack_public_path__ + "static/media/dimidel.746431e6.png";